<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex 
            xs12 
            px-3 
            pt-3
          >
            <div class="title">
                Encuestas UG | Vista Previa Encuesta
            </div>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="mt-3 px-3">
        <div v-if="oidcUser">
          <div v-if="loading">
            <v-layout wrap>
              <v-flex 
                xs12 
                text-sm-right 
                py-3
              >
                <v-skeleton-loader type="card" />
              </v-flex>
            </v-layout>
          </div>
          <encuesta v-else :obj-encuesta="objEncuesta" :img-portada="imgPortada" :parametros="parametros" token-resultado="" :vista-previa="true"></encuesta>
          <v-alert 
              v-else 
              :type="typeAlert">
              {{ alert }}
          </v-alert>
        </div>
        <v-alert 
          v-else 
          type="warning">
          Por favor actualice la página e inicie sesión.
        </v-alert>
      </v-card-text>
    </v-card>
   

    <v-snackbar
        key="snackbar_encuesta"
        v-model="snackbar"
        :bottom="true"
        :multi-line="true"
        :color="snackbarColor"
    >
        {{ snackbarTexto }}
        <v-btn 
            dark 
            text 
            @click="snackbar = false">
            Cerrar
        </v-btn>
    </v-snackbar>
  </v-container>

</template>


<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { getEncuestaVistaPrevia } from "@/api";

export default {
  name: "EncuestaVistaPrevia",
  components: {
    Encuesta: () =>
      import("../../components/encuesta/Encuesta"),
  },
  props: {
    idEncuesta: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    parametros: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      objEncuesta: {},
      imgPortada: null,
      settings: {
        maxScrollbarLength: 60,
      },
      loading: true,
      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",
      alert: '',
      typeAlert: ''
    };
  },
  computed: {
    ...mapGetters("oidc", ["oidcUser", "oidcAccessToken"]),  
  },
  beforeMount () {},
  mounted () {    
    this.obtenerEncuesta();
  },
  methods: {
    async obtenerEncuesta () {
      var self = this;
      self.loading = true;

      /* self.snackbar = false;
      self.snackbarTexto = "";
      self.snackbarColor = ""; */
      self.alert = '';
      self.typeAlert = '';

      try {
        let response = await getEncuestaVistaPrevia(self.idEncuesta, self.token);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              self.objEncuesta = response.data.data.encuesta;
              if(response.data.data.objPortada != null){
                self.imgPortada = 'data:image/png;base64,' + response.data.data.objPortada.docto;
              }
            }
            else{              
/*               self.snackbarTexto = response.data.message;
              self.snackbarColor = "warning";
              self.snackbar = true; */
              self.alert  = response.data.message;
              self.typeAlert = "warning"
            }
          } else {
/*             self.snackbarTexto = response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true; */

            self.alert  = response.data.message;
            self.typeAlert = "error"
          }
          self.loading = false;
        } else {          
          /* self.snackbarTexto = "Error de red";
          self.snackbarColor = "error";
          self.snackbar = true; */

          self.alert  = "Error de red";
          self.typeAlert = "error"

          self.loading = false;
        }
      } catch (e) {
        /* self.snackbarTexto = e;
        self.snackbarColor = "error";
        self.snackbar = true; */

        self.alert  = e;
        self.typeAlert = "error"

        self.loading = false;
      }
    },
  },
};
</script>
